import PropTypes from 'prop-types';
import React from 'react';

import RichTextWithGlossary from '$partials/glossary/rich-text-with-glossary.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleStepsBlock = ({
    items,
    isAccordionOrSection,
    isFirstInAccordion,
    isDetailPage
}) => {

    return (
        <section className='layout-container relative md:flex'>
            <div className='md:w-1/12' />
            <div className='md:w-11/12'>
                {items?.map((item, idx) => {
                    return (
                        <React.Fragment key={idx}>
                            <div
                                className={`${idx !== 0 ? 'border-t border-t-charcoal' : isAccordionOrSection && !isFirstInAccordion ? 'border-t border-t-charcoal' : ''} mb-40 sm:mb-20 ${idx === items.length-1 ? 'md:mb-60' : 'md:mb-40'} sm:flex`}>
                                <div className='sm:w-4/12 md:flex md:w-4/11'>
                                    <p className='type-style-4 mt-40 mb-30 sm:mb-20 md:mr-20'>{`Step ${idx+1}`}</p>
                                    {item.heading && (
                                        <h2 className='type-style-3 mb-30 md:mt-40'>{item.heading}</h2>
                                    )}
                                </div>
                                {item.body && (
                                    <RichTextWithGlossary
                                        className='rich-text type-style-4 sm:w-8/12 sm:mt-40 sm:px-10 md:w-6/11'
                                        html={item.body} />
                                )}
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    isAccordionOrSection: PropTypes.bool,
    isFirstInAccordion: PropTypes.bool,
    isDetailPage: PropTypes.bool,
    items: PropTypes.array
};


ModuleStepsBlock.propTypes = propTypes;

export default ModuleStepsBlock;
